import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'normalize.css/normalize.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';
import '@blueprintjs/datetime/lib/css/blueprint-datetime.css';
import '@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css';
import './styles/custom.css';
import './styles/dev.css';
import 'react-overlay-loader/styles.css';
import 'react-select/dist/react-select.css';


window.document.title = process.env.REACT_APP_PROJECT_TITLE;
process.env.REACT_APP_RESTART_SESSION = false;

ReactDOM.render(<App />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js